import { render, staticRenderFns } from "./commonCard.vue?vue&type=template&id=6822e913&scoped=true"
import script from "./commonCard.vue?vue&type=script&lang=js"
export * from "./commonCard.vue?vue&type=script&lang=js"
import style0 from "./commonCard.vue?vue&type=style&index=0&id=6822e913&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6822e913",
  null
  
)

export default component.exports